<template>
    <div id="popup-container">
        <v-toolbar dark color="primary">
            <v-toolbar-title class="heading-title">
                Edit {{ $globalConfig.APP_NAME === 'senso' ? 'Site' : 'Location'}}
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn fab x-small class="close" @click="closePanel">
                <v-icon dark>fa-times</v-icon>
            </v-btn>
        </v-toolbar>
        <v-container>
            <v-layout>
                <v-flex xs12>
                    <v-card flat>
                        <v-form>
                            <v-text-field
                                :error-messages="messages.name"
                                v-model="location.name"
                                :label="$globalConfig.APP_NAME === 'senso' ? 'Site Name' : 'Location Name'"
                                type="text"
                                filled
                                class="input-width"
                               
                            ></v-text-field>
                        </v-form>
                    </v-card>
                </v-flex>
            </v-layout>
        </v-container>
        <v-footer absolute height="68">
            <v-flex px-4 py-4 text-right>
                <v-btn v-if="!loading" color="grey300" class="mr-4 cancel-button" @click="closePanel">Cancel</v-btn>
                <v-btn v-if="loading" color="primary" loading></v-btn>
                <v-btn v-else color="primary" class="add-course-button"  @click="updateSite">Save</v-btn>
            </v-flex>
        </v-footer>
    </div>
</template>
<script>
    import { EventBus } from "@/event-bus.js";
    import companyAPI from "@/api/company.js";

    export default {
        name: "Edituser",
        props: {
            site: {
                type: Object
            },
        },
        data() {
            return {
                messages: {},
                valid: true,
                successMessage: `${this.$globalConfig.APP_NAME === 'senso' ? 'Site' : 'Location'} Successfully Updated.`,
                errorMessage: "Oops, something went wrong! Please check information is correct.",
                loading: false,
                location : { ...this.site }
            };
        },
        methods: {
            closePanel() {
                this.$emit("closePanel", {});
            },
            updateSite() {
                this.loading=true;
                companyAPI
                .updateSite(this.location)
                .then(() => {
                    this.loading=false;
                    this.closePanel();
                    EventBus.$emit("SITES_UPDATED");
                    this.$snotify.success(this.successMessage);
                    this.loading=false;
                })
                .catch(err => {
                    this.loading=false;
                    this.valid = false;
                    this.messages = this.$gf.errorResponse(err);
                    let errMsg = err.response.data.message;
                    if(errMsg) {
                        this.errorMessage = errMsg;
                        this.$snotify.error(errMsg);
                    }else{
                        this.$snotify.error(this.errorMessage);
                    }
                    this.loading=false;
                });
            },
        }
    };
</script>
